import {
  inject,
  observer,
} from 'mobx-react';

import {
  WeaRadioGroup,
} from 'ecCom'

import React from 'react'
import * as mobx from 'mobx'

const toJS = mobx.toJS;

@inject('hrmPerStatusReport')

@observer
class RadioGroupWrapper extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.init();
  }

  init() {
    const {
      hrmPerStatusReport
    } = this.props;
    hrmPerStatusReport.getSearchCondition();
  }

  render() {
    const {
      hrmPerStatusReport
    } = this.props;
    const {
      condition1
    } = hrmPerStatusReport;
    let arr = toJS(condition1);

    return (
      <div style={{padding: '16px 16px 8px 16px'}}>
              <WeaRadioGroup ecId={`${this && this.props && this.props.ecId || ''}_WeaRadioGroup@nq5drg`}
                  config={arr}
                  onChange={(params) => {hrmPerStatusReport.setParams(params)}}
              />
          </div>
    )
  }
}

export default RadioGroupWrapper


// WEBPACK FOOTER //
// ../src4js/pc4mobx/hrm/components/report/RadioGroupWrapper.js